import { environment } from '../../../environments/environment';

// En modo desarrollo, podemos necesitar la ruta para pruebas
export const BASE = environment.production ? 'seguros/movilidad/motos/cotizador' : '';

function buildPathFinalPage(path: string): string {
  return BASE ? `${BASE}/final_page/${path}` : `final_page/${path}`;
}

// Paginas finales constantes
export const SARLAFT_DENIED = 'sarlaft_denied';
export const CONTACT_THE_REGISTRY = 'contact_the_registry';
export const CHECK_THE_INFORMATION = 'check_the_information';
export const ERROR_500 = 'error_500';
export const PROBLEMAS_TECNICOS = 'problemas_tecnicos';
export const INFORMACION_FASECOLDA = 'informacion_fasecolda';

//Páginas Finales Redirect
export const SARLAFT_DENIED_REDIRECT = buildPathFinalPage('sarlaft_denied');
export const CONTACT_THE_REGISTRY_REDIRECT = buildPathFinalPage('contact_the_registry');
export const CHECK_THE_INFORMATION_REDIRECT = buildPathFinalPage('check_the_information');
export const ERROR_500_REDIRECT = buildPathFinalPage('error_500');
export const PROBLEMAS_TECNICOS_REDIRECT = buildPathFinalPage('problemas_tecnicos');
export const INFORMACION_FASECOLDA_REDIRECT = buildPathFinalPage('informacion_fasecolda');
